export default __webpack_public_path__ + "assets/8c666342651f83a4382e27a2be3fccf9.png";